var map = {
	"./akynara.jpg": "L1Yf",
	"./aquiles.jpg": "rrfE",
	"./cassio.jpeg": "l7NA",
	"./giovanni.jpeg": "5lxy",
	"./jadiliana.png": "Okxy",
	"./mara.jpeg": "+JDS",
	"./oscar.jpeg": "HPQS"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0/Qy";